import PropTypes from 'prop-types';

const menu = (country, isConsentFlagActive) => {
  const links = [
    {
      href: '/legal/terms',
      label: 'account.consent_manager.vertical_nav.terms_of_service',
    },
    {
      href: '/legal/privacy',
      label:
        'account.consent_manager.vertical_nav.privacy_and_cookie_statement',
    },
    {
      href: '/legal/takedown',
      label: 'account.consent_manager.vertical_nav.notice_and_takedown_policy',
    },
    {
      href: '/legal/disclosure',
      label:
        'account.consent_manager.vertical_nav.responsible_disclosure_policy',
    },
    {
      href: '/legal/advertising',
      label:
        'account.consent_manager.vertical_nav.advertising_terms_and_conditions',
    },
  ];

  const isCountryUS = country?.toUpperCase() === 'US';

  if (isConsentFlagActive) {
    links.splice(2, 0, {
      href: '/legal/manage-cookies',
      label: 'account.consent_manager.vertical_nav.your_privacy_choices',
    });

    if (isCountryUS) {
      links.splice(3, 0, {
        href: '/legal/ccpa',
        label: 'transfer.consent-manager.button-ccpa',
      });
    }
  }

  return links;
};

menu.propTypes = {
  country: PropTypes.string.isRequired,
  isConsentFlagActive: PropTypes.boolean,
};

menu.defaultProps = {
  isConsentFlagActive: false,
};

export default menu;
